<template>
  <section class="section-cards">
    <section-header :title="section.title" />
    <div
      v-if="showDescription(section) && isDesktop"
      v-dompurify-html="section.description"
      class="section-description"
    />

    <div class="cards-container">
      <card
        v-for="(card, index) in section.items"
        :key="`card_${index}`"
        v-bind="card"
      />
    </div>
  </section>
</template>

<script>
  import get from 'lodash-es/get'
  import { mapGetters } from 'vuex'

  export default {
    name: "CardSection",
    components: {
      'card': () => import(/* webpackChunkName: "card-component" */ 'components/Card/Card'),
      'section-header': () => import(/* webpackChunkName: "index-section-header" */ 'containers/Pages/IndexPage/SectionHeader'),
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters('device', [
        'isDesktop'
      ])
    },
    methods: {
      showDescription (section) {
        return get(section, 'description', '') !== ''
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .section-cards {
    padding: 28px 0;

    .section-description {
      @include defaultFontValues($blue-dark, 22, 34, 300);
      padding: 0 12px;
      margin-bottom: 40px;

      @include bp-mf-desktop-large {
        padding: 0;
      }
    }

    .cards-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      overflow-y: hidden;
      overflow-x: auto;
      padding: 0 12px 20px 0;

      @include bp-mf-desktop-large {
        overflow: hidden;
        padding: 0 0 20px;
      }
    }
  }

</style>
